export const THROTTLE_DELAY_100 = 100;
export const DEBOUNCE_DELAY_300 = 300;
export const DEBOUNCE_DELAY_150 = 150;
